import { startNumberTicker } from './number-ticker';


startNumberTicker();


import { updateVariantLegend } from './variant-updater';

updateVariantLegend();